// 4 px base grid. Named steps keep sx/props readable. Existing xs–3xl
// tokens preserved for backwards-compat; the numeric scale below adds
// the larger 64 / 80 / 96 / 128 / 160 px steps for marketing-page rhythm.
export const spacing = {
  unit: 4,

  // legacy / dense product UI
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  "2xl": 48,
  "3xl": 64,

  // numeric scale (8 pt-grid-aligned, marketing-page rhythm)
  "0": 0,
  "1": 4,
  "2": 8,
  "3": 12,
  "4": 16,
  "5": 20,
  "6": 24,
  "8": 32,
  "10": 40,
  "12": 48,
  "16": 64,
  "20": 80,
  "24": 96,
  "32": 128,
  "40": 160,
} as const;
